<ng-container *ngIf="isLoading">


    <div class="fixed inset-0 z-50 flex items-center justify-center min-h-[300px]">
        <p-progress-spinner ariaLabel="loading" />
    </div>
</ng-container>

<div class="bg-gray-20 ">
    <div class="container mx-auto mb-80 lg:mb-20">
        <div class="flex flex-col md:gap-4 mx-auto mt-6 ">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="flex flex-col w-full">
                    <label class="font-medium">Current Password</label>
                    <p-password formControlName="oldPassword" [toggleMask]="true" [feedback]="false"
                        styleClass="w-full block"
                        inputStyleClass="w-full h-[35px] border rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed">
                    </p-password>
                    <small class="text-red-500 block min-h-[1rem]"
                        [ngClass]="{ 'invisible': !getFieldError('oldPassword')}">
                        {{ getFieldError('oldPassword') || '' }}
                    </small>
                    <ng-container *ngIf="!isValidOldPassword">
                        <small class="text-red-500 block min-h-[1rem]">
                            Invalid current password
                        </small>
                    </ng-container>
                </div>
                <div class="mt-5 mb-12  flex flex-col w-full">
                    <label class="font-medium">New Password</label>
                    <p-password formControlName="password" [toggleMask]="true" [feedback]="false"
                        styleClass="w-full block"
                        inputStyleClass="w-full h-[35px] border rounded-md px-3 py-2 text-sm disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed">
                    </p-password>
                    <div class="flex items-center">
                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                        <p class="text-[var(--fs-black)] text-sm ml-2">7-32 characters - letters AND numbers</p>
                    </div>
                    <small class="text-red-500 block min-h-[1rem]"
                        [ngClass]="{ 'invisible': !getFieldError('password')}">
                        {{ getFieldError('password') || '' }}
                    </small>
                </div>
                <div class="flex grid grid-cols-3 gap-x-[30px] gap-y-[15px] mt-[30px] flex-wrap-reverse">
                    <div class="lg:col-span-1 col-span-3 lg:order-0 order-1">
                        <button pButton type="button" [routerLink]="['/my-account']"
                            class="h-[35px] !font-noto-serif w-full !font-normal"
                            [outlined]="true">
                            Back
                        </button>
                    </div>
                    <div class="lg:col-span-2 col-span-3 lg:order-1 order-0">
                        <button pButton 
                            class="h-[35px] !font-noto-serif w-full" type="submit"
                            [disabled]="form.invalid ">
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>